import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/Footer'
import RecordingInformationPage from '../views/patientInformation/RecordingInformationPage';

const RecordingInformation = () => {
    window.scrollTo(0, 0);

    return (
        <>
            <Header />
            <RecordingInformationPage />
            <Footer />
        </>
    )
}

export default RecordingInformation
